<template>
  <div>
    <list-block>
      <list-filter
        ref="listRef"
        :field="organizationalSearchField"
        @queryData="queryData"
        @resetData="resetData"
      />
    </list-block>
    <list-block>
      <div class="create-btn">
        <el-button
          type="primary"
          @click="created()"
        >
          添加
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="TableList"
        border
      >
        <el-table-column
          v-for="item in ORGANIZATIONALTABLECOLUMN"
          :key="item.props"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'action'">
              <el-button
                v-if="!isAuth(scope.row.authStatus)"
                type="text"
                @click="InviteAuth(scope.row)"
              >
                邀请认证
              </el-button>
              <el-button
                type="text"
                @click="authorization(scope.row)"
              >
                授权
              </el-button>
            </div>
            <span
              v-else-if="item.prop === 'enterpriseName'"
              class="link"
              @click="handleDetail(scope.row)"
            >
              {{ scope.row[item.prop] }}
            </span>
            <span
              v-else
              v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
            />
          </template>
        </el-table-column>
      </el-table>
      <pagination
        ref="SitePagination"
        :total="pagination.total"
        :current-page.sync="pagination.page"
        @search="fetchData"
      />
    </list-block>
    <editDialog ref="editDialog" @reset="resetData" />
    <detailDialog
      ref="detailDialog"
      :is-view-auth-user="isViewAuthUser"
      @reset="resetData"
    />
    <InviteAuthDialog ref="InviteAuthDialog" />
    <authorizationDialog ref="authorizationDialog" />
  </div>
</template>

<script>
import { mainManagePage } from '@/api/principal';
import ListBlock from '@/components/ListBlock/index.vue';
import pagination from '@/components/Pagination/index.vue';
import { searchFormFilter } from '@/utils/index';
import { mapState } from 'vuex';
import ButtonPermission from '@/constant/buttonPermission';
import ListFilter from './ListFilter.vue';
import {
  organizationalSearchField, ORGANIZATIONALTABLECOLUMN, organizationalField, MAIN_TYPE, AuthStatus,
} from '../constant';
import editDialog from './editDialog.vue';
import detailDialog from './detailDialog.vue';
import InviteAuthDialog from './InviteAuthDialog.vue';
import authorizationDialog from './authorizationDialog.vue';
import Servers from '../../../../env/index';

export default {
  name: 'OrganizationalChart',
  components: {
    ListBlock, ListFilter, pagination, editDialog, detailDialog, InviteAuthDialog, authorizationDialog,
  },
  data() {
    return {
      ORGANIZATIONALTABLECOLUMN: [],
      organizationalSearchField,
      TableList: [],
      loading: false,
      pagination: {
        total: null,
        page: 1,
        size: 10,
      },
      searchForm: {}, // 搜索
    };
  },
  computed: {
    ...mapState('user', ['buttonsPermission']),
    isAuth() {
      return (authStatus) => authStatus === AuthStatus.AUTHED;
    },
    isViewAuthUser() {
      if (this.buttonsPermission && this.buttonsPermission.length) {
        return this.buttonsPermission.some((item) => item.uri === ButtonPermission.principalManageAuth);
      }
      return false;
    },
  },
  created() {
    this.ORGANIZATIONALTABLECOLUMN = ORGANIZATIONALTABLECOLUMN(this.isViewAuthUser);
    this.fetchData();
  },
  methods: {
    async fetchData(page, size) {
      this.loading = true;
      this.pagination.page = page || this.pagination.page;
      this.pagination.size = size || this.pagination.size;
      const params = {
        ...this.searchForm,
        mainType: MAIN_TYPE.ENTERPRISE,
      };
      try {
        const res = await mainManagePage({ ...searchFormFilter(params) }, { page: this.pagination.page, size: this.pagination.size });
        this.TableList = res.records;
        this.pagination.total = res.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    queryData(form) {
      this.searchForm = form;
      this.pagination.page = 1;
      this.fetchData();
    },
    resetData() {
      this.searchForm = {};
      this.pagination.page = 1;
      this.fetchData();
    },
    created() {
      // 新增
      this.$refs.editDialog.show({ title: '添加组织机构', mainType: MAIN_TYPE.ENTERPRISE, fields: organizationalField.edit });
    },
    handleDetail(row) {
      this.$refs.detailDialog.show({
        title: row.enterpriseName, id: row.id, mainType: MAIN_TYPE.ENTERPRISE, type: 'detail', fields: organizationalField,
      });
    },
    InviteAuth(row) {
      // 邀请认证
      this.$refs.InviteAuthDialog.show({ title: `邀请认证(${row.enterpriseName})`, row, url: `${Servers.FE_CONSIGNOR_H5}/#/mainAuth/enterpriseAuth?code=${row.creditCode}` });
    },
    authorization(row) {
      // 授权
      this.$refs.authorizationDialog.show({ title: `授权列表(${row.enterpriseName})`, creditCode: row.creditCode });
    },
  },
};
</script>

<style lang="scss" scoped>

.create-btn {
  margin-bottom: 12px;
  // text-align: right;
}
.link{
  color: #06B880;
  cursor: pointer;
}
</style>
